import { config } from 'react-spring'

import ROUTES from '~/shared/constants/routes.const'
interface ItemLinks {
  [key: string]: string
}

export const checklistLinks: ItemLinks = {
  createAvatar: ROUTES.DASHBOARD,
  verifyEmail: ROUTES.ONBOARDING_EMAIL_VERIFY,
}

export const IMAGES_COUNT = 35
export const SPRITE_COLS = 7
export const SPRITE_ROWS = 5

export const SPRING_CONFIG = {
  config: config.wobbly,
  from: { transform: 'scale(0)' },
  to: { transform: 'scale(1)' },
}

export enum HighlightIds {
  EXPLORE_SPACE = 'explore-space',
  EXPLORE_LEADERBOARD = 'explore-leaderboard',
  MATH_TASK = 'math-task',
  MASTERY_TRACK = 'mastery-track',
}
